import styled from 'styled-components';

import mediaQueries from '@/theme/mediaQueries';
import { borderRadius } from '@/theme/selectors';

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    max-width: 600px;

    ${mediaQueries.laptop} {
        border-radius: ${borderRadius('medium')};
    }
`;

export const Image = styled.div<{ $image?: string }>`
    flex-shrink: 0;
    width: 100%;
    height: 240px;
    background-image: ${({ $image }) => ($image ? `url(${$image})` : 'none')};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
`;

export const Content = styled.div`
    flex: 1;
    background-color: ${({ theme }) => theme['surface-default']};
    padding: 24px 16px;
`;
